import React from 'react';
import { Text } from '../../components/base/Text';
import { UserView } from './UserView';
import { OrganizationView } from './OrganizationView';
export const ProfileView = ({ profileSections }) => {
    const sectionMapping = {
        user: UserView,
        organization: OrganizationView,
    };
    return (React.createElement("div", { className: "flex-column", style: { padding: '3vw', overflowY: 'auto', gap: 24 } },
        React.createElement(Text, { value: 'Profile', className: "header1" }),
        profileSections.map((section, index) => {
            const SectionComponent = sectionMapping[section];
            return React.createElement(SectionComponent, { key: index });
        })));
};
